import React from "react";
import { useNavigate } from "react-router-dom";
import { IoArrowBack } from "react-icons/io5";

const AddProductsScreen = () => {
  const navigate = useNavigate();

  const handleLearn = () => {
    console.log("Learn button clicked");
  };

  const handleAddProducts = () => {
    navigate("/add-product");
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="flex items-center gap-4 bg-white px-6 py-4 shadow-sm">
        <button onClick={() => navigate(-1)} className="text-gray-900">
          <IoArrowBack className="h-6 w-6" />
        </button>
        <h1 className="flex-1 text-center text-lg font-semibold text-gray-900">
          Add Products
        </h1>
        <div className="w-6" />
      </header>

      <main className="px-6 py-6">
        <section className="mb-6 rounded-lg bg-white p-6 shadow-sm">
          <h2 className="text-base font-semibold text-gray-900">
            Welcome to BUY iT add products
          </h2>
          <p className="mt-3 text-sm text-gray-600">
            Want to learn how to upload your product on BUY iT to prevent rejections, click on the "Learn" button
          </p>
          <button
            onClick={handleLearn}
            className="mt-4 w-full rounded-lg bg-[#19C463] py-3 text-sm font-semibold text-white transition-colors hover:bg-[#14a352]"
          >
            Learn
          </button>
        </section>

        <section className="rounded-lg bg-white p-6 shadow-sm">
          <div className="flex flex-col items-center">
            <div className="mb-4 flex h-32 w-32 items-center justify-center rounded-lg bg-gray-100">
              <svg
                className="h-16 w-16 text-gray-400"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                />
              </svg>
            </div>
            <h3 className="text-center text-base font-semibold text-gray-900">
              Add a new product
            </h3>
            <p className="mt-2 text-center text-sm text-gray-600">
              Fill in your product details one at a time
            </p>
            <button
              onClick={handleAddProducts}
              className="mt-6 w-full rounded-lg bg-[#19C463] py-3 text-sm font-semibold text-white transition-colors hover:bg-[#14a352]"
            >
              Add Products
            </button>
          </div>
        </section>
      </main>
    </div>
  );
};

export default AddProductsScreen;
